import { ExpenseInput } from '@/types/expense';
import { filterValueToQuery } from '@/api';

export default function expense(axios: any) {
  async function getExpenses(filter: any) {
    try {
      const response = await axios.get(`/api/Expenses?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/expense] getExpenses Error', e);
    }
    return null;
  }

  async function getExpenseTypes(filter: any) {
    try {
      const response = await axios.get(`/api/ExpenseType?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/expense] getExpenseTypes Error', e);
    }
    return null;
  }

  async function getExpense(id: number) {
    const response = await axios.get(`/api/Expenses/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/expense] updateExpense Error', e);
    }
    return null;
  }

  async function createExpense(bomCostId: number, payload: ExpenseInput) {
    const response = await axios.post(`/api/bom_costs/${bomCostId}/costs`, payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/expense] createExpense Error', e);
    }
    return null;
  }

  async function updateExpense(id: number | string, payload: ExpenseInput) {
    const response = await axios.put(`/api/Expenses/${id}`, payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/expense] updateExpense Error', e);
    }
    return null;
  }

  async function deleteExpense(id: number) {
    const response = await axios.delete(`/api/Expenses/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/expense] updateExpense Error', e);
    }
    return null;
  }

  return {
    getExpenses,
    getExpenseTypes,
    getExpense,
    createExpense,
    updateExpense,
    deleteExpense,
  };
}
